import Vue from 'vue'

export default {

    /**
     * Set tasks
     * @param state
     * @param taskusers
     * @constructor
     */
    SET_TASKUSERS(state, taskusers) {

        //console.log(taskusers);

        // Tasks can be a single task or tasks list
        if (!Array.isArray(taskusers)) taskusers = [taskusers];

        // Get user id
        const user = window.app.$get('auth/currentUser');

        // Save each task from list to state
        taskusers.forEach(i => {

            // Check for position mode
            const curUser = ((i.user_type.indexOf("_position") > 0 && user.positions.includes(i.user_id)) ? true : (user.id == i.user_id ? true : false)) ? 'i_' : 'o_';

            // Check is task deleted
            if(i.deleted_at)
            {
                // Check for user
                if(state.taskIndex[i.task_id] !== undefined && state.taskIndex[i.task_id][curUser+i.user_type] !== undefined) Vue.delete(state.taskIndex[i.task_id],curUser+i.user_type);

                // Delete task
                Vue.delete(state.taskusers, i.id);
            }
            else {
                // Store task
                Vue.set(state.taskusers, i.id, i);

                // Index user tasks
                if (!state.taskIndex[i.task_id]) Vue.set(state.taskIndex, i.task_id, {});
                Vue.set(state.taskIndex[i.task_id], curUser+i.user_type, 1);
            }
        });
    },

    /**
     * Delete taskusers
     * @param state
     * @param task
     * @constructor
     */
    DELETE_TASKUSERS(state, taskusers) {

        // Tasks can be a single task or tasks list
        if (!Array.isArray(taskusers)) taskusers = [taskusers];

        // Save each task from list to state
        taskusers.forEach(i => {
            Vue.delete(state.taskusers, i.id);
        });
    },
}
